import gql from "graphql-tag";

export const viewerQuery = gql`
  query viewer {
    viewer {
      id
      roles
    }
  }
`;

export interface Viewer {
  id: string;
  roles: string[];
}

export interface ViewerResult {
  viewer: Viewer;
}

export const modelFieldsFragment = gql`
  fragment ModelFields on Model {
    id
    workspaceId
    reportId
    displayName
    slug
    launchDate
    productId
    participantCount
    dataset
    description
    embargoEndDate
    roles
    searchText
    favoriteType
    tags
    vendors: vendorsExtra {
      id
      slug
      name
    }
  }
`;

export interface GetModelResult {
  getModel: Model;
}

export interface GetModelVariables {
  id: string;
}

export const getModelQuery = gql`
  query getModel($id: String) {
    getModel(id: $id) {
      ...ModelFields
    }
  }
  ${modelFieldsFragment}
`;

export interface Vendor {
  id: string;
  slug: string;
  name: string;
}

export interface Model {
  id: string;
  displayName: string;
  reportId: string;
  workspaceId: string;
  launchDate: string;
  participantCount: number;
  slug: string;
  vendors: Vendor[];
  description?: string;
  productId?: string;
  dataset: string;
  favoriteType: string;
  roles: string[];
  embargoEndDate?: string;
  tags: string[];
}

export interface ModelResult {
  model: Model;
  payload: string;
  message: string;
}

export interface ModelInput {
  roles?: string[];
  workspaceId: string;
  reportId: string;
  displayName: string;
  description: string;
  vendors?: string[];
  launchDate: string;
  embargoEndDate: string | null;
  participantCount: number;
  dataset: string;
  slug: string;
  productId?: string;
  tags?: string[];
}

export interface CreateModelResult {
  createModel: ModelResult;
}

export interface CreateModelVariables {
  model: ModelInput;
}

export const createModelMutation = gql`
  mutation CreateModel($model: ModelInput!) {
    createModel(model: $model) {
      model {
        ...ModelFields
      }
      payload
      message
    }
  }
  ${modelFieldsFragment}
`;

export interface UpdateModelResult {
  updateModel: ModelResult;
}

export interface UpdateModelVariables {
  id: string;
  model: ModelInput;
}

export const updateModelMutation = gql`
  mutation UpdateModel($id: String!, $model: ModelInput!) {
    updateModel(id: $id, model: $model) {
      model {
        ...ModelFields
      }
      payload
      message
    }
  }
  ${modelFieldsFragment}
`;

export const COMMON_RESPONSE_PAYLOADS = {
  INVALID_PERMISSION: "invalidPermissions",
  INVALID_OBJECT_ID: "invalidObjectID",
  INVALID_ROLE: "nonExistingRoles",
  SLUG_EXISTS: "slugExists",
  REPORT_ID_EXISTS: "reportIdExists",
};

export const MODEL_RESPONSE_PAYLOAD = {
  UPDATE: {
    ...COMMON_RESPONSE_PAYLOADS,
    ERROR: "errorUpdatingModel",
    SUCCESS: "updatedModel",
  },
  CREATE: {
    ...COMMON_RESPONSE_PAYLOADS,
    ERROR: "errorCreatingModel",
    SUCCESS: "createdModel",
  },
};
